const Action = require("../base/Action");

class Button extends Action {

    get buttonType(){
        let types = {
            "primary": "btn",
            "small": "btn less-spacing",
            "titleButton": "btn select-btn title",
            "uppercase": "btn uppercase",
            "secondary": "btn secondary",
            "grey": "btn grey",
            "grey-big": "btn grey big",
            "outline": "btn grey outline",
            "outline-danger": "btn red outline",
            "smallOutline": "btn grey outline small",
            "arrow": "btn arrow-right less-spacing",
            "edit": "btn edit-btn",
            "close": "btn close",
            "expand": "expand",
            "delete": "btn delete less-spacing",
            "add": "btn text-add",
            "arrowDown": "btn arrow arrow-down",
            "arrowUp": "btn arrow arrow-up",
            "print": "print",
            "goldenArrow": "btn arrow-right centered pushed-down less-spacing",
            "pagination": "pagination-item",
            "pagination-next": "pagination-item next",
            "pagination-prev": "pagination-item prev",
            "action": "action",
            "action-red": "action red",
            "select": "select-btn",
            "minimal": "minimal",
            "create": "btn create",
            "exit": "btn exit",
            "goto": "btn goto",
            'critical': 'btn delete uppercase centered title',
            "none": ""
        }

        return types;
    }

    get type(){
        return this.props.type || "primary"
    }

    get label(){
        if(this.props.label){
            return this.props.label;
        }
        return this.props.children;
    }

    get defaultClassNames() {
    	return this.buttonType[this.type];
    }

    get title() {
        return this.props.title || '';
    }

    render(){
        return(
            <button type="button"
                    title={this.title}
                    className={this.classNames}
                    disabled={this.props.disabled}
                    onClick={this.onAction.bind(this)}>{this.label}</button>
        );
    }

}

module.exports = Button;
